import { render, staticRenderFns } from "./ChartDataSettings.vue?vue&type=template&id=85a097a0&scoped=true"
import script from "./ChartDataSettings.vue?vue&type=script&lang=ts"
export * from "./ChartDataSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a097a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a097a0')) {
      api.createRecord('85a097a0', component.options)
    } else {
      api.reload('85a097a0', component.options)
    }
    module.hot.accept("./ChartDataSettings.vue?vue&type=template&id=85a097a0&scoped=true", function () {
      api.rerender('85a097a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ChartDataSettings.vue"
export default component.exports